import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Profile } from '@shared/models/profile';
import { Observable, Subject } from 'rxjs';

import accountMock from '@mocks/account.json';
import accountEkMock from '@mocks/accountEk.json';

import { ProfileEk } from '@shared/models/profile-ek';

@Injectable({
    providedIn: 'root'
})
export class ProfileService {

    private profile: Profile;
    private profileEk: ProfileEk;

    constructor(
        private commonService: CommonService,
        private http: HttpClient
    ) {
        this.profile = accountMock;
        this.profileEk = accountEkMock;
    }

    public getAccount(): Observable<Profile> {
        if (this.commonService.useMocks) {
            return new Observable(observer => observer.next(this.profile));
        }
        return this.http.get<Profile>(this.commonService.getServiceUrl(`account`));
    }

    public getAccountEk(personalNumber: string, lastName: string): Observable<ProfileEk> {

        if (this.commonService.useMocks) {
            return new Observable(observer => observer.next(this.profileEk));
        }

        return this.http.get<ProfileEk>(this.commonService.getServiceUrl(`account/ek`), {
            params: new HttpParams()
                .set('lastName', lastName)
                .set('personalNumber', personalNumber)
        });
    }

    public postDeleteAccount(password: string): Observable<object> {
        return this.http.post(this.commonService.getServiceUrl(`account/delete`), {
            password: password
        });
    }

    public postUpdatePassword(current: string, newPassword: string, newRepeat: string) {
        return this.http.post(this.commonService.getServiceUrl(`account/password`), {
            currentPassword: current,
            newPassword: newPassword,
            newRepeat: newRepeat,
        });
    }

    public postNotificationApproval(stopNotificationApproval: boolean) {
        return this.http.post(this.commonService.getServiceUrl(`account/notification`), {
            stopNotificationApproval: stopNotificationApproval
        });
    }

    public postMKTApproval(
        firstName: string,
        lastName: string,
        personalNumber: string,
        partId: string,
    ) {
        return this.http.post(this.commonService.getServiceUrl(`account/mkt`), {
            firstName: firstName,
            lastName: lastName,
            personalNumber: personalNumber,
            partId: partId,
        });
    }

    public postMKTApprovalCancel(
        firstName: string,
        lastName: string,
        personalNumber: string,
    ) {
        return this.http.post(this.commonService.getServiceUrl(`account/mkt/cancel`), {
            firstName: firstName,
            lastName: lastName,
            personalNumber: personalNumber,
        });
    }

    public postAccountUpdate(action: string, data: object) {
        return this.http.post(this.commonService.getServiceUrl(`change`), {
            action: action,
            data: data,
        });
    }

    public postUnifyContacts() {
        return this.http.post(this.commonService.getServiceUrl(`account/unify-contacts`), null);
    }

    public getIdentityCardTypes() {
        return this.http.get(this.commonService.getServiceUrl(`account/identity-card-types`));
    }

    public getCountries() {
        return this.http.get(this.commonService.getServiceUrl(`account/countries`));
    }

    public getZips() {
        return this.http.get<Array<string>>(this.commonService.getServiceUrl(`account/zips`));
    }

    public getCitiesByZip(zip: string) {
        return this.http.get<Array<string>>(this.commonService.getServiceUrl(`account/cities/${zip}`));
    }

    public getStreetsByZipCity(zip: string, city: string) {
        return this.http.get<Array<string>>(this.commonService.getServiceUrl(`account/streets`), {
            params: (new HttpParams()).set('zip', zip).set('city', city)
        });
    }

    public generateSMSCode(mobile: string, action: string) {
        return this.http.post(this.commonService.getServiceUrl(`account/generate-sms-code`), {
            mobile: mobile,
            action: action,
        });
    }

    public validateSMSCode(smsCode: string, action: string) {
        return this.http.post(this.commonService.getServiceUrl(`account/validate-sms-code`), {
            smsCode: smsCode,
            action: action,
        });
    }
}
